export default __webpack_public_path__ + "static/media/icono-abstracto-alt.69929c53.svg";